import { getDuration } from '@plugins/biPoint/utils';
import { sendStayTime } from '@plugins/biPoint/_configOfficialSupport';
export default {
  data() {
    return {
      startTime: new Date(),
      pageName: this.$route.meta.pageName,
      isKeepAlive: false
    };
  },
  methods: {
    initStayInfo() {
      this.startTime = new Date();
      window.pointPageName = this.pageName;
    },
    sendStayTime() {
      const duration = getDuration(this.startTime);
      sendStayTime({
        locationKey: this.pageName,
        duration
      });
    }
  },
  beforeCreate() {
    if (this.$route.meta.isKeepAlive) {
      this.keepAlive = true;
    }
  },
  created() {
    if (!this.keepAlive) {
      this.initStayInfo();
    }
  },
  beforeDestroy() {
    if (!this.keepAlive) {
      this.sendStayTime();
    }
  },
  activated() {
    this.initStayInfo();
  },
  deactivated() {
    this.sendStayTime();
  }
};
